const SAMPLE_RATE = 0.15;

interface ContextConfig {
    app: { name: string; version: string };
    user: {
        fullName?: string;
        email?: string;
        publicId?: string;
    };
    env: string;
    sampleValue?: number;
}

export const initDatadogRUM = ({
    app,
    user,
    env,
    sampleValue,
}: ContextConfig) =>
    import('@eventbrite/real-user-monitoring').then(
        ({ EBEnvsEnum, initializeRealUserMonitoring, setUser }) => {
            initializeRealUserMonitoring({
                sessionSampleRate: sampleValue || SAMPLE_RATE,
                service: app.name,
                version: app.version,
                env: env === EBEnvsEnum.PROD ? EBEnvsEnum.PROD : EBEnvsEnum.QA,
            });

            if (user.email) {
                setUser({
                    id: user.publicId,
                    name: user.fullName,
                    email: user.email,
                });
            }
        },
    );
